<template>
  <el-dialog
    fullscreen
    title="请选一张正面且清晰的照片，作为门店的参考门头照在任务的详情页展示。"
    custom-class="task-review-evidence-dialog dark"
    :visible.sync="visible">
    <div class="tred-container">
      <div class="tred-container-left">
        <view-image
          ref="viewImage"
          :index="viewIndex"
          :files="files"
          :visible="visible"
          @changeIndex="onChangeIndex"
          :toolbar="toolbar"/>
      </div>
      <div class="tred-container-right"
           v-perfect-scrollbar.relative="{suppressScrollX:true}">
        <div class="margin m-b-15"></div>
        <p style="font-size: 16px;line-height: 2">请选一张正面且清晰的照片，作为门店的参考门头照在任务的详情页展示。</p>
          <el-button type="success"
                     @click="choose"
                     icon="el-icon-success">启用门头照</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ViewImage from '@views/question-review/components/AnswerFileFullScreen/src/ViewImage.vue'

export default {
  mixins: [],
  components: {ViewImage},
  data () {
    return {
      viewIndex: 0,
      files: [],
      visible: false,
      activeNames: ['1', '2'],
      toolbar: {},
      chooseOne: () => {},
    }
  },
  computed: {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {},
  methods: {
    choose () {
      this.chooseOne(this.viewIndex)
      this.visible = false
    },
    onChangeIndex (index) {
      this.viewIndex = index
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/question-review/components/MarketPhotoFullScreen/src/main.vue